import React from 'react'

const NotFound = () => {
  return (
    <h1 className='title'>Page Not Found</h1>
  )
}

export default NotFound